import { Layout, Space } from 'antd'
import { useLayoutEffect, useRef, useState } from 'react'
import { LoadingAnimation } from './LoadingAnimation'

export default function GlobalPageLoading({ pageLoading }) {
  const [internalLoading, setInternalLoading] = useState(false)
  const timeout = useRef(null)

  useLayoutEffect(() => {
    // Debounce the loading state to prevent flickering
    if (pageLoading) {
      timeout.current = setTimeout(() => {
        setInternalLoading(true)
      }, 500)
      if (timeout.current && internalLoading) {
        clearTimeout(timeout.current)
      }
    }

    if (pageLoading === false) {
      clearTimeout(timeout.current)
      timeout.current = setTimeout(() => {
        setInternalLoading(false)
      }, 33)
    }
  }, [setInternalLoading, internalLoading, pageLoading])

  if (!internalLoading) return null

  return (
    <Layout
      style={{
        position: 'absolute',
        left: '50%',
        top: '300px',
        transform: 'translate(-50%, -50%)',
      }}
    >
      <Space size="large" style={{ margin: 'auto' }}>
        <LoadingAnimation />
      </Space>
    </Layout>
  )
}
